module.exports = __webpack_public_path__ + "static/media/allergynew.48baeee7.svg";